[
  {
    "id": "ball",
    "player_level": 1,
    "encyclopedia_order": 101
  },
  {
    "id": "starball",
    "player_level": 1,
    "encyclopedia_order": 102
  },
  {
    "id": "crab",
    "player_level": 1,
    "encyclopedia_order": 201
  },
  {
    "id": "hamster",
    "player_level": 1,
    "encyclopedia_order": 202
  },
  {
    "id": "turtle",
    "player_level": 1,
    "encyclopedia_order": 203
  },
  {
    "id": "beetle",
    "player_level": 1,
    "encyclopedia_order": 204
  },
  {
    "id": "mouse",
    "player_level": 1,
    "encyclopedia_order": 205
  },
  {
    "id": "chick",
    "player_level": 1,
    "encyclopedia_order": 206
  },
  {
    "id": "mushroom",
    "player_level": 1,
    "encyclopedia_order": 207
  },
  {
    "id": "frog",
    "player_level": 1,
    "encyclopedia_order": 208
  },
  {
    "id": "jellyfish",
    "player_level": 1,
    "encyclopedia_order": 209
  },
  {
    "id": "squirrel",
    "player_level": 1,
    "encyclopedia_order": 210
  },
  {
    "id": "fish",
    "player_level": 1,
    "encyclopedia_order": 211
  },
  {
    "id": "dog",
    "player_level": 1,
    "encyclopedia_order": 301
  },
  {
    "id": "seaotter",
    "player_level": 1,
    "encyclopedia_order": 302
  },
  {
    "id": "cat",
    "player_level": 1,
    "encyclopedia_order": 303
  },
  {
    "id": "whitedog",
    "player_level": 1,
    "encyclopedia_order": 304
  },
  {
    "id": "rabbit",
    "player_level": 1,
    "encyclopedia_order": 306
  },
  {
    "id": "bear",
    "player_level": 1,
    "encyclopedia_order": 307
  },
  {
    "id": "browndog",
    "player_level": 1,
    "encyclopedia_order": 308
  },
  {
    "id": "graydog",
    "player_level": 1,
    "encyclopedia_order": 309
  },
  {
    "id": "pig",
    "player_level": 1,
    "encyclopedia_order": 310
  },
  {
    "id": "penguin",
    "player_level": 1,
    "encyclopedia_order": 311
  },
  {
    "id": "bluedog",
    "player_level": 1,
    "encyclopedia_order": 312
  },
  {
    "id": "whale",
    "player_level": 1,
    "encyclopedia_order": 401
  },
  {
    "id": "giraffe",
    "player_level": 1,
    "encyclopedia_order": 402
  },
  {
    "id": "pinkdog",
    "player_level": 1,
    "encyclopedia_order": 403
  },
  {
    "id": "panda",
    "player_level": 1,
    "encyclopedia_order": 404
  },
  {
    "id": "dinosaur",
    "player_level": 1,
    "encyclopedia_order": 405
  },
  {
    "id": "elephant",
    "player_level": 1,
    "encyclopedia_order": 406
  },
  {
    "id": "lion",
    "player_level": 1,
    "encyclopedia_order": 407
  },
  {
    "id": "reindeer",
    "player_level": 1,
    "encyclopedia_order": 408
  },
  {
    "id": "polarbear",
    "player_level": 1,
    "encyclopedia_order": 409
  },
  {
    "id": "alpaca",
    "player_level": 1,
    "encyclopedia_order": 410
  },
  {
    "id": "tiger",
    "player_level": 1,
    "encyclopedia_order": 411
  },
  {
    "id": "sealion",
    "player_level": 1,
    "encyclopedia_order": 313
  },
  {
    "id": "flamingo",
    "player_level": 1,
    "encyclopedia_order": 412
  },
  {
    "id": "cow",
    "player_level": 1,
    "encyclopedia_order": 413
  },
  {
    "id": "persiancat",
    "player_level": 1,
    "encyclopedia_order": 314
  },
  {
    "id": "dolphin",
    "player_level": 1,
    "encyclopedia_order": 414
  }
]
